import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ProjectAlarmsLocationRemoveListComponent} from './steps/project-alarms-location/project-alarms-location-remove-list/project-alarms-location-remove-list.component';
import {ProjectAlarmsUserRemoveListComponent} from './steps/project-alarms-user/project-alarms-user-remove-list/project-alarms-user-remove-list.component';
import {AlarmService} from '../../../shared/services/alarm/alarm.service';
import {StatesService} from '../../../shared/services/state/states.service';
import {ReferentialService} from '../../../shared/services/referential/referential.service';
import {ToastrService} from 'ngx-toastr';
import {MatStepper} from '@angular/material/stepper';
import * as moment from 'moment';
import {StaticAmplitudeAlarmParameters} from '../../../shared/classes/alarms/alarm-parameters/static-amplitude-alarm-parameters';
import {StaticThresholdAlarmParameters} from '../../../shared/classes/alarms/alarm-parameters/static-threshold-alarm-parameters';
import {CombinationAlarmParameters} from '../../../shared/classes/alarms/alarm-parameters/combination-alarm-parameters';
import {AlarmsTypes} from '../../../shared/types/alarms.types';
import AlarmLocation = AlarmsTypes.AlarmLocation;
import AlarmUser = AlarmsTypes.AlarmUser;
import AlarmValidator = AlarmsTypes.AlarmValidator;
import {AlarmsConstants} from '../../../shared/constants/alarms.constants';
import ALARM_TYPE = AlarmsConstants.ALARM_TYPE;
import ALARM_WITH_GENERIC_PARAM = AlarmsConstants.ALARM_WITH_GENERIC_PARAM;
import ALARM_WITH_LOCATIONS = AlarmsConstants.ALARM_WITH_LOCATIONS;
import ALARM_TYPE_OPERATING_DEFAULT = AlarmsConstants.ALARM_TYPE_OPERATING_DEFAULT;
import REFERENCE_TYPE = AlarmsConstants.REFERENCE_TYPE;
import {DevicesTypes} from '../../../shared/types/devices.types';
import deviceType = DevicesTypes.deviceType;
import {DevicesConstants} from '../../../shared/constants/devices.constants';
import DEVICE_TYPES_FOR_ALARMS = DevicesConstants.DEVICE_TYPES_FOR_ALARMS;
import {ReferentialTypes} from '../../../shared/types/referential.types';
import GenericReferentialType = ReferentialTypes.GenericReferentialType;
import ALARM_TYPE_DATA_USAGE = AlarmsConstants.ALARM_TYPE_DATA_USAGE;

@Component({
  selector: 'app-project-alarms-crud',
  templateUrl: './project-alarms-crud.component.html',
  styleUrls: ['./project-alarms-crud.component.css']
})
export class ProjectAlarmsCrudComponent implements OnInit {


  public alarmsTypes: GenericReferentialType[];
  public reminderIntervals: GenericReferentialType[];
  public alarmTypeSelected: string = ALARM_TYPE.LIRIS_LOCATION;
  public alarmLocationsList: AlarmLocation[] = [];
  public alarmUsersList: AlarmUser[] = [];
  public alarmValidatorsList: AlarmValidator[] = [];
  public alarmsTypeForm = new FormGroup(
    {
      name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(50)])
    }
  );
  public alarmsDataUsageForm = new FormGroup(
    {
      volume: new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
      period: new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
      active: new FormControl(true, [Validators.required])
    }
  );
  public alarmsConsolidatedEventDynForm = new FormGroup(
    {
      events: new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
      range: new FormControl('', [Validators.required, Validators.pattern(/^-?\d+(\.\d+)?$/)]), // Utilisation d'une expression régulière pour accepter les nombres flottants
    }
  );
  public showSpinner: boolean = false;
  public invalidFields = [];
  public alarmGenericParams: StaticAmplitudeAlarmParameters | StaticThresholdAlarmParameters | CombinationAlarmParameters;
  public alarmsWithGenericParams = ALARM_WITH_GENERIC_PARAM;
  public alarmTypesWithLocations = ALARM_WITH_LOCATIONS;
  public low: boolean = false;
  public medium: boolean = false;
  public high: boolean = false;
  public opParamsActive: boolean = ALARM_TYPE_OPERATING_DEFAULT.ACTIVE;
  public opParamsDeviceType: number = ALARM_TYPE_OPERATING_DEFAULT.DEVICE_TYPE;
  public opParamsStartingMode: string = ALARM_TYPE_OPERATING_DEFAULT.STARTING_MODE;
  public opParamsReminderInterval: string = ALARM_TYPE_OPERATING_DEFAULT.REMINDER_INTERVAL;
  public opParamsPeriod: number = ALARM_TYPE_OPERATING_DEFAULT.PERIOD;
  public usDaysInterval: number;
  public usMoUsage: number;
  public usParamsActive: boolean = ALARM_TYPE_DATA_USAGE.ACTIVE;
  public dateStart: Date;
  public date: FormControl;
  public event_dyn_range: number;
  public event_dyn_events: number;

  @Input('readOnly') public readOnly: boolean = false;
  @Input('alarmId') public alarmId: number = null;
  @Input('projectId') public projectId: number;
  @Input('mode') public mode: string;
  @Input('alarmIsLevelValidable') public alarmIsLevelValidable: boolean = false;
  @ViewChild(ProjectAlarmsLocationRemoveListComponent) public projectAlarmsLocationRemoveListComponent: ProjectAlarmsLocationRemoveListComponent;
  @ViewChild(ProjectAlarmsUserRemoveListComponent) public projectAlarmsUserRemoveListComponent: ProjectAlarmsUserRemoveListComponent;
  @ViewChild('stepper') public stepper: MatStepper;
  @ViewChild('masterLocation') public masterLocation: ProjectAlarmsLocationRemoveListComponent;
  @ViewChild('masterUser') public masterUser: ProjectAlarmsUserRemoveListComponent;
  @ViewChild('masterValidator') public masterValidator: ProjectAlarmsUserRemoveListComponent;


  readonly DEVICE_TYPES_FOR_ALARMS: deviceType[] = DEVICE_TYPES_FOR_ALARMS;
  readonly ALARM_TYPE = ALARM_TYPE;

  private alarms: any = {};

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private alarmService: AlarmService,
    private stateService: StatesService,
    private referentialService: ReferentialService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    this.showSpinner = true;
    if (this.alarmId !== null) {
      this.alarmService.getAlarms(this.alarmId)
        .subscribe(
          (alarm: any) => {
            this.showSpinner = false;
            this.alarmsTypeForm.patchValue({name: alarm.name});
            this.alarmTypeSelected = alarm.type;
            this.alarmUsersList = this.setAlarmUsersList(alarm);
            this.alarmValidatorsList = this.setAlarmValidatorsList(alarm);
            this.alarmLocationsList = this.setAlarmLocationsList(alarm);
            this.initThresholdAlarmProperties(alarm);
            this.initOperatingAlarmProperties(alarm);
            this.initUsageAlarmProperties(alarm);
            this.initConsolidatedEventDynAlarmProperties(alarm);
            this.initGenericAlarmsProperties(alarm);
          },
          () => {
            this.showSpinner = false;
          }
        );
    } else {
      this.dateStart = new Date();
      this.date = new FormControl(this.dateStart);
      this.referentialService.getReferential(REFERENCE_TYPE.ALARM_TYPE)
        .subscribe(
          (alarmTypes: GenericReferentialType[]) => {
            this.alarmsTypes = alarmTypes;
            this.showSpinner = false;
          });
    }
    this.loadAlarmInterval();
  }

  loadAlarmInterval() {
    this.referentialService.getReferential(REFERENCE_TYPE.ALARM_REMINDER_INTERVAL)
      .subscribe((alarmReminderIntervals: GenericReferentialType[]) => {
        this.reminderIntervals = alarmReminderIntervals;
      });
  }

  getCheckSaveIndex(): number {
    let index = 2;
    const alarmsTypesFourSteps = [
      ALARM_TYPE.LIRIS_LOCATION,
      ALARM_TYPE.COMBINATION,
      ALARM_TYPE.DATA_USAGE
    ];

    const alarmsTypesFiveSteps = [
      ALARM_TYPE.THRESHOLD,
      ALARM_TYPE.STATIC_AMPLITUDE,
      ALARM_TYPE.STATIC_THRESHOLD,
      ALARM_TYPE.OPERATING,
      ALARM_TYPE.CONSOLIDATED_EVENT_DYN
    ];

    if (alarmsTypesFourSteps.includes(this.alarmTypeSelected)) {
      index = 3;
    }

    if (alarmsTypesFiveSteps.includes(this.alarmTypeSelected)) {
      index = 4;
    }

    return this.alarmIsValidable() ? index + 1 : index;
  }


  alarmIsValidable(): boolean {
    return this.alarmIsLevelValidable && this.alarmTypeSelected === ALARM_TYPE.OPERATING;
  }

  saveAlarm() {

    this.showSpinner = true;
    this.alarms = {
      name: this.alarmsTypeForm.value.name,
      type: this.alarmTypeSelected,
      active: true,
      subscriptions: this.masterUser.subscriptions,
      validators: this.alarmIsValidable() ? this.masterValidator?.validators : []
    };
    this.setParams();
    this.setLocations();
    if (this.alarmId !== null) {
      this.alarmService.putAlarm(this.alarmId, this.alarms)
        .subscribe(
          (data) => {
            this.toastr.success(this.alarmIsValidable() ? this.translate.instant('ALARM_TO_VALID') : this.translate.instant('ALARM_MODIFIED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
            this.stateService.reloadProjectAlarms.next();
            this.activeModal.close();
          },
          error1 => {
            this.showSpinner = false;
          });
    } else {
      this.alarmService.postAlarm(this.projectId, this.alarms)
        .subscribe(
          (data) => {
            this.toastr.success(this.translate.instant('ALARM_ADDED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
            this.stateService.reloadProjectAlarms.next();
            this.activeModal.close();
          },
          error1 => {
            this.showSpinner = false;
          });
    }
  }

  signalInvalidValues() {
    this.toastr.error(this.translate.instant('INVALID_VALUES'));
  }

  private setParams() {
    if (this.alarms.params !== undefined) {
      delete this.alarms.params;
    }

    if (this.alarmTypeSelected === ALARM_TYPE.THRESHOLD) {
      this.alarms.params = {
        low: this.low ? 1 : 0,
        medium: this.medium ? 1 : 0,
        high: this.high ? 1 : 0,
      };
    }

    if (this.alarmTypeSelected === ALARM_TYPE.OPERATING) {
      const formatTime = (value: number) => value < 10 ? '0' + value.toString() : value;
      const date: Date = this.date.value;

      const stringDate = moment.isMoment(date) ? date.format('YYYY-MM-DD HH:mm:ss') : `${formatTime(date.getUTCFullYear())}-${formatTime(date.getUTCMonth() + 1)}-${formatTime(date.getUTCDate())} ${formatTime(date.getUTCHours())}:${formatTime(date.getUTCMinutes())}:${formatTime(date.getUTCSeconds())}`;

      this.alarms.params = {
        device_type: this.opParamsDeviceType,
        starting_mode: this.opParamsStartingMode,
        reminder_interval: this.opParamsReminderInterval,
        starting_at: stringDate,
        period: this.opParamsDeviceType !== 1 ? this.opParamsPeriod : 24,
        active: this.opParamsActive
      };
    }
    if (this.alarmTypeSelected === ALARM_TYPE.DATA_USAGE) {
      this.alarms.params = {
        period: this.usDaysInterval,
        volume: this.usMoUsage,
      };
    }

    if (this.alarmTypeSelected === ALARM_TYPE.CONSOLIDATED_EVENT_DYN) {
      this.alarms.params = {
        range: this.event_dyn_range,
        events: this.event_dyn_events
      };
    }

    if (this.alarmsWithGenericParams.includes(this.alarmTypeSelected)) {
      this.alarms.params = this.alarmGenericParams;
    }

  }

  private setLocations() {
    if (this.alarms.locations !== undefined) {
      delete this.alarms.locations;
    }

    if (this.alarmTypesWithLocations.includes(this.alarmTypeSelected)) {
      this.alarms.locations = this.masterLocation.locations;
    }
  }

  setAlarmType(type: string) {
    this.alarmTypeSelected = this.alarmTypeSelected !== type ? type : AlarmsConstants.ALARM_TYPE.LIRIS_LOCATION;
  }

  public get name() {
    return this.alarmsTypeForm.get('name');
  }

  public get volume() {
    return this.alarmsDataUsageForm.get('volume');
  }

  public get period() {
    return this.alarmsDataUsageForm.get('period');
  }

  public get range() {
    return this.alarmsConsolidatedEventDynForm.get('range');
  }

  public get events() {
    return this.alarmsConsolidatedEventDynForm.get('events');
  }

  public getErrorMessageName(): string {

    if (this.name.errors.required) {
      return this.translate.instant('VALUE_FORM_REQUIRED');
    }

    if (this.name.errors.minlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_SHORT');
    }

    if (this.name.errors.maxlength) {
      return this.translate.instant('VALUE_USER_NAME_TOO_LONG');
    }

    return '';
  }

  private setAlarmUsersList(alarm: any): AlarmUser[] {
    let alarmUsersList: AlarmUser[] = [];
    alarm.alarm_subscriptions.forEach((alarm_subscription) => {
      alarmUsersList.push({
        id: alarm_subscription.user.id,
        email: alarm_subscription.user.username,
        lastname: alarm_subscription.user.lastname,
        firstname: alarm_subscription.user.firstname,
        phone: alarm_subscription.user.phone,
        send_email: alarm_subscription.send_email,
        send_sms: alarm_subscription.user.phone ? alarm_subscription.send_sms : false,
        send_voice: alarm_subscription.user.phone ? alarm_subscription.send_voice : false
      });
    });
    return alarmUsersList;
  }

  private setAlarmValidatorsList(alarm: any): AlarmValidator[] {
    let alarmValidatorsList: AlarmValidator[] = [];
    alarm.alarm_validators.forEach((alarm_subscription) => {
      alarmValidatorsList.push({
        id: alarm_subscription.user.id,
        email: alarm_subscription.user.username,
        lastname: alarm_subscription.user.lastname,
        firstname: alarm_subscription.user.firstname,
        phone: alarm_subscription.user.phone
      });
    });
    return alarmValidatorsList;
  }

  private setAlarmLocationsList(alarm: any): AlarmLocation[] {
    let alarmLocationsList: AlarmLocation[] = [];
    alarm.project_device_location_alarms.forEach((project_device_location_alarm) => {
      alarmLocationsList.push({
        id: project_device_location_alarm.project_device_location.id,
        name: project_device_location_alarm.project_device_location.name
      });
    });
    return alarmLocationsList;
  }

  private initThresholdAlarmProperties(alarm: any): void {
    if (this.alarmTypeSelected === ALARM_TYPE.THRESHOLD) {
      this.low = parseInt(alarm.params.low, 10) === 1;
      this.medium = parseInt(alarm.params.medium, 10) === 1;
      this.high = parseInt(alarm.params.high, 10) === 1;
    }
  }

  private initOperatingAlarmProperties(alarm: any): void {
    if (this.alarmTypeSelected === ALARM_TYPE.OPERATING) {
      this.opParamsDeviceType = alarm.params.device_type;
      this.opParamsStartingMode = alarm.params.starting_mode;
      this.opParamsReminderInterval = alarm.params.reminder_interval;
      this.dateStart = new Date(typeof alarm.params.starting_at !== 'undefined' ? alarm.params.starting_at.date : '');
      // hack which add time-zone offset
      // cause mat-datepicker set to UTC and date from api are UTC yet: check providers on app.modules
      this.dateStart.setHours(this.dateStart.getHours() - ((new Date()).getTimezoneOffset() / 60));
      this.date = new FormControl(this.dateStart);

      this.opParamsPeriod = alarm.params.period;
      this.opParamsActive = alarm.params.active;
    }
  }

  private initUsageAlarmProperties(alarm: any): void {
    if (this.alarmTypeSelected === ALARM_TYPE.DATA_USAGE) {
      this.usDaysInterval = alarm.params.period;
      this.usMoUsage = alarm.params.volume;
      this.usParamsActive = alarm.active;
    }
  }

  private initConsolidatedEventDynAlarmProperties(alarm: any): void {
    if (this.alarmTypeSelected === ALARM_TYPE.CONSOLIDATED_EVENT_DYN) {
      this.event_dyn_events = alarm.params.events;
      this.event_dyn_range = alarm.params.range;
    }
  }

  private initGenericAlarmsProperties(alarm: any): void {
    if (this.alarmsWithGenericParams.includes(this.alarmTypeSelected)) {
      this.alarmGenericParams = alarm.params;
    }
  }
}
